const PageTitle = ({ children }) => (
  <div className="text-gray-800 dark:text-gray-100 text-4xl font-bold leading-snug">
    {children}
  </div>
);

export default PageTitle;
